import { render, staticRenderFns } from "./InfoPage.vue?vue&type=template&id=781953d0&scoped=true&"
import script from "./InfoPage.vue?vue&type=script&lang=js&"
export * from "./InfoPage.vue?vue&type=script&lang=js&"
import style0 from "./InfoPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./InfoPage.vue?vue&type=style&index=1&id=781953d0&lang=scss&scoped=true&"
import style2 from "./InfoPage.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781953d0",
  null
  
)

export default component.exports